import {getLookUpQueryList} from "../module/system/js/ApiSystem";

/**
 * 快码ID配置
 * @type {{lookUpTypeId: string}}
 */
const lookUpIdObject = {
    lookUpTypeId: '2efc0819-a92e-4fe8-87c3-0b154aec234e',//快码类别
    isChoiceId: 'f8964701-56ff-45f5-8ac6-594a4bc6649a',//“是/否”快码ID
    judge: '87701599-f2ee-4ada-8489-ba214263ebb3',// 判断条件
    dataPowerLevelId: '12312312',//用户数据权限级别缓存
};


/**
 * 快码缓存
 * @param lookUpId 快码ID
 * @param Callback 回调函数
 */
function getLookUpCache(lookUpId, Callback) {
    let loopUpJSON = sessionStorage.getItem('LookUp');
    if (loopUpJSON === null || loopUpJSON.length < 1) {
        getLookUpQueryList({}).then(res => {
            sessionStorage.setItem('LookUp', JSON.stringify(res.data.data));
            let item = res.data.data.find(item => {
                return item.id === lookUpId
            });
            console.log(1,res)
            Callback(item)
        })
    } else {
        let lookUp = JSON.parse(loopUpJSON);
        let item = lookUp.find(item => {
            return item.id === lookUpId
        });
        Callback(item)
    }
}


/**
 * 获取快码类型
 * @param callback
 */
export function getLookUpType(callback) {
    getLookUpCache(lookUpIdObject.lookUpTypeId, (res) => {
        callback(res.lookUpLines);
    });
}


/**
 * 获取"是，否"选择类型
 * @param callback
 */
export function getIsChoice(callback) {
    getLookUpCache(lookUpIdObject.isChoiceId, (res) => {
        callback(res.lookUpLines);
    });
}


/**
 * 获取"性别"选择类型
 * @param callback
 */
export function getGender(callback) {
    getLookUpCache(lookUpIdObject.genderId, (res) => {
        callback(res.lookUpLines);
    });
}


/**
 * 获取联系人快码
 * @param callback
 */
export function getContacts(callback) {
    getLookUpCache(lookUpIdObject.contactsId, (res) => {
        callback(res.lookUpLines);
    });
}
/**
 * 获取判断条件
 * @param callback
 */
export function getJudge(callback) {
    getLookUpCache(lookUpIdObject.judge, (res) => {
        callback(res.lookUpLines);
    });
}
/**
 * 获取用户数据权限级别
 * @param callback
 */
export function getDataPowerLevel(callback) {
    getLookUpCache(lookUpIdObject.dataPowerLevelId, (res) => {
        callback(res.lookUpLines);
    });
}


